<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="isCreate ? $t('companies.softwares.create_title') : $t('companies.softwares.edit_title')"
  :rightActions="rightActions"
  width="620"
)
  UiFormGroup(:label="$t('companies.softwares.software')")
    UiMultiselect(
      v-model="form.name"
      :options="softwaresOptions"
      :canClear="false"
      :canDeselect="false"
      @update:modelValue="v$.$reset()"
    )

  template(v-if="form.name == 'netvisor'")
    UiFormGroup(
      :label="$t('companies.softwares.netvisor_user_id')"
      :vuelidateModel="v$.form.options.netvisor_user_id"
    )
      UiInput(
        v-model="form.options.netvisor_user_id"
        :error="v$.form.options.netvisor_user_id.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.netvisor_user_secret')"
      :vuelidateModel="v$.form.options.netvisor_user_secret"
    )
      UiInput(
        v-model="form.options.netvisor_user_secret"
        :error="v$.form.options.netvisor_user_secret.$error"
      )

  template(v-if="form.name == 'fortnox'")
    UiFormGroup(:label="$t('companies.softwares.fortnox_auth_code')")
      UiInput(v-model="form.options.fortnox_auth_code")

  template(v-if="form.name == 'procountor' && procountorLink")
    UiFormGroup
      UiButton(
        :href="procountorLink"
        variant="smooth-primary"
      ) {{ $t("companies.softwares.procountor_link") }}

  template(v-if="form.name == 'maventa'")
    UiFormGroup(
      :label="$t('companies.softwares.maventa_user_api_key')"
      :vuelidateModel="v$.form.options.user_api_key"
    )
      UiInput(
        v-model="form.options.user_api_key"
        :error="v$.form.options.user_api_key.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.maventa_company_uuid')"
      :vuelidateModel="v$.form.options.company_uuid"
    )
      UiInput(
        v-model="form.options.company_uuid"
        :error="v$.form.options.company_uuid.$error"
      )

  template(v-if="form.name == 'netsuite'")
    UiFormGroup(
      :label="$t('companies.softwares.netsuite_consumer_key')"
      :vuelidateModel="v$.form.options.netsuite_consumer_key"
    )
      UiInput(
        v-model="form.options.netsuite_consumer_key"
        :error="v$.form.options.netsuite_consumer_key.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.netsuite_consumer_secret')"
      :vuelidateModel="v$.form.options.netsuite_consumer_secret"
    )
      UiInput(
        v-model="form.options.netsuite_consumer_secret"
        :error="v$.form.options.netsuite_consumer_secret.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.netsuite_access_token')"
      :vuelidateModel="v$.form.options.netsuite_access_token"
    )
      UiInput(
        v-model="form.options.netsuite_access_token"
        :error="v$.form.options.netsuite_access_token.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.netsuite_access_secret')"
      :vuelidateModel="v$.form.options.netsuite_access_secret"
    )
      UiInput(
        v-model="form.options.netsuite_access_secret"
        :error="v$.form.options.netsuite_access_secret.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.netsuite_realm')"
      :vuelidateModel="v$.form.options.netsuite_realm"
    )
      UiInput(
        v-model="form.options.netsuite_realm"
        :error="v$.form.options.netsuite_realm.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.netsuite_script_id')"
      :vuelidateModel="v$.form.options.netsuite_script_id"
    )
      UiInput(
        v-model="form.options.netsuite_script_id"
        :error="v$.form.options.netsuite_script_id.$error"
      )
    UiFormGroup(
      :label="$t('companies.softwares.netsuite_subsidiary_id')"
      :vuelidateModel="v$.form.options.netsuite_subsidiary_id"
    )
      UiInput(
        v-model="form.options.netsuite_subsidiary_id"
        :error="v$.form.options.netsuite_subsidiary_id.$error"
      )

  template(v-if="form.name == 'basware'")
    UiFormGroup(
      :label="$t('companies.softwares.basware_company_id')"
      :vuelidateModel="v$.form.options.basware_company_id"
    )
      UiInput(
        v-model="form.options.basware_company_id"
        :error="v$.form.options.basware_company_id.$error"
      )

    UiFormGroup(
      v-for="option in baswareStorageSettings"
      :key="option"
    )
      UiInputLabel
        strong {{ $t(`companies.softwares.basware_${option}_folder`) }}
      UiStack
        UiStackItem(fill)
          UiFormGroup(
            :label="$t('companies.softwares.storages')"
            :vuelidateModel="v$.form.options[`basware_${option}_storage_id`]"
          )
            UiMultiselect(
              :modelValue="form.options[`basware_${option}_storage_id`]"
              :error="v$.form.options[`basware_${option}_storage_id`].$error"
              :options="storageOptions"
              :disabled="loading"
              @update:modelValue="clearFolder($event, `basware_${option}_folder`, `basware_${option}_storage_id`)"
            )
        UiStackItem(fill)
          UiFormGroup(
            :label="$t('companies.softwares.folder')"
            :vuelidateModel="v$.form.options[`basware_${option}_folder`]"
          )
            UiMultiselect(
              v-model="form.options[`basware_${option}_folder`]"
              :error="v$.form.options[`basware_${option}_folder`].$error"
              :options="getFoldersList(form.options[`basware_${option}_storage_id`])"
              :disabled="loading"
            )
</template>

<script>
import ApiCompanySoftwares from "@/api/companySoftwares.js";
import ApiCompanyStorages from "@/api/companyStorages.js";
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        options: {
          netvisor_user_id: {
            required: requiredIf(this.form.name == "netvisor"),
          },
          netvisor_user_secret: {
            required: requiredIf(this.form.name == "netvisor"),
          },

          user_api_key: {
            required: requiredIf(this.form.name == "maventa"),
          },
          company_uuid: {
            required: requiredIf(this.form.name == "maventa"),
          },

          netsuite_consumer_key: {
            required: requiredIf(this.form.name == "netsuite"),
          },
          netsuite_consumer_secret: {
            required: requiredIf(this.form.name == "netsuite"),
          },
          netsuite_access_token: {
            required: requiredIf(this.form.name == "netsuite"),
          },
          netsuite_access_secret: {
            required: requiredIf(this.form.name == "netsuite"),
          },
          netsuite_realm: {
            required: requiredIf(this.form.name == "netsuite"),
          },
          netsuite_script_id: {
            required: requiredIf(this.form.name == "netsuite"),
          },
          netsuite_subsidiary_id: {
            required: requiredIf(this.form.name == "netsuite"),
          },

          basware_company_id: {
            required: requiredIf(this.form.name == "basware"),
          },
          ...this.baswareStorageSettings.reduce(
            (acc, option) => ({
              ...acc,
              [`basware_${option}_folder`]: {
                required: requiredIf(this.form.name == "basware"),
              },
              [`basware_${option}_storage_id`]: {
                required: requiredIf(this.form.name == "basware"),
              },
            }),
            {},
          ),
        },
      },
    };
  },

  data() {
    return {
      show: false,
      isCreate: false,
      companyId: null,
      procountorLink: null,
      form: {},
      storageOptions: [],
      storagePath: {},
      foldersList: {},
      loading: false,
      softwaresOptions: [
        { label: "Netvisor", value: "netvisor" },
        { label: "Procountor", value: "procountor" },
        { label: "FortNox", value: "fortnox" },
        { label: "NetSuite", value: "netsuite" },
        { label: "BasWare", value: "basware" },
        { label: "Maventa", value: "maventa" },
      ],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },

    baswareStorageSettings() {
      return [
        "vendors",
        "dimensions",
        "invoices",
        "vouchers",
        "learning",
        "suggested_invoices",
      ];
    },
  },

  methods: {
    open(companyId, Software) {
      this.v$.$reset();
      if (Software) {
        this.isCreate = false;
        this.form = {
          id: Software.id,
          name: (Software.name || "").toLowerCase(),
          options: Software.options,
        };
      } else {
        this.isCreate = true;
        this.form = {
          name: "netvisor",
          options: {},
        };
      }
      this.companyId = companyId;
      this.show = true;
      this.getProcountorLink();
      this.getSftpConnections(); //TODO - only for basware
    },

    close() {
      this.show = false;
    },

    getProcountorLink() {
      if (this.procountorLink) {
        return;
      }
      ApiCompanySoftwares.getProcountorLink(this.companyId).then((resp) => {
        this.procountorLink = resp.data.link;
      });
    },

    clearFolder(event, folder, field) {
      this.form = {
        ...this.form,
        options: {
          ...this.form.options,
          [folder]: null,
          [field]: event,
        },
      };
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          software: {
            name: form.name,
            options: form.options,
          },
        };
        const companyId = this.companyId;
        if (this.isCreate) {
          ApiCompanySoftwares.createSoftware(companyId, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        } else {
          ApiCompanySoftwares.updateSoftware(companyId, form.id, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        }
      });
    },

    getFoldersList(sftp_id) {
      if (sftp_id === undefined) {
        return [];
      } else {
        return this.foldersList[sftp_id];
      }
    },

    getSftpConnections() {
      this.loading = true;

      ApiCompanyStorages.fetchStorages(this.$route.params.id).then((resp) => {
        this.storageOptions = resp.data.sftp.map((connection) => ({
          label: connection.name,
          value: connection.id,
        }));

        const folders = resp.data.sftp.map((element) => {
          this.storagePath[element.id] = element.remote_path;
          return ApiCompanyStorages.SFTPFolderList(
            this.$route.params.id,
            element.remote_path,
            element.id,
          ).then((resp_folders) => {
            this.foldersList = {
              ...this.foldersList,
              [element.id]: resp_folders.data.folders,
            };
            this.foldersList[element.id].unshift("/");
          });
        });
        Promise.allSettled(folders).then(() => {
          this.loading = false;
        });
      });
    },
  },
};
</script>
